module.exports = __webpack_public_path__ + "static/img/DSC00601.99c71e3b.jpg";